import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePermissoes } from '../hooks/usePermissoes';
import { Dropdown, Menu, Modal, Form, Input, message, Button } from 'antd';
import { UserOutlined, KeyOutlined, LogoutOutlined, DownOutlined } from '@ant-design/icons';
import { usuarioService } from '../services/api';
import '../styles/Sidebar.css';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const { podeVisualizar, isAdmin, loading: permissaoLoading, permissoes } = usePermissoes();
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
  const [isSenhaModalVisible, setIsSenhaModalVisible] = useState(false);
  const [emailForm] = Form.useForm();
  const [senhaForm] = Form.useForm();

  console.log('[Sidebar] user:', user);
  console.log('[Sidebar] user.role:', user?.role);
  console.log('[Sidebar] user.perfil:', user?.perfil);
  console.log('[Sidebar] user.id_perfil:', user?.id_perfil);

  if (!user) return null;

  const toggleSubmenu = (label) => {
    setOpenSubmenu(openSubmenu === label ? null : label);
  };

  const menuItensIds = Array.isArray(user?.menu_itens_ids)
    ? user.menu_itens_ids
    : Array.isArray(user?.perfil?.menu_itens_ids)
      ? user.perfil.menu_itens_ids
      : [];
  const menuItensIdsSet = new Set(menuItensIds);

  const menuItemIdsByRoute = {
    '/dashboard': [1, 20],
    '/dashboard-executivo-v2': [1, 20],
    '/dashboard-rentabilidade': [1, 20],
    '/dashboard-financeiro': [21],
    '/dashboard-operacional': [22],
    '/dashboard-comercial': [23],
    '/dashboard-rh': [24],
    '/dashboard-unidades': [25],
    '/responsavel/dashboard': [26],
    '/unidades': [2],
    '/tipo-unidades': [3],
    '/tipo-contratos': [4],
    '/modalidades': [5],
    '/equipe': [6],
    '/turmas': [7],
    '/alunos': [8],
    '/matriculas': [9],
    '/contratos': [28],
    '/aulas-dadas': [10],
    '/fornecedores': [11],
    '/categorias-despesa': [12],
    '/despesas': [13],
    '/receitas': [14],
    '/fluxo-caixa': [15],
    '/folha-pagamento': [16],
    '/responsaveis/pendentes': [17],
    '/usuarios': [18],
    '/perfis': [19],
  };

  const perfilTemMenuItem = (path) => {
    if (!menuItensIds || menuItensIds.length === 0) return true;
    const ids = menuItemIdsByRoute[path];
    if (!ids || ids.length === 0) return true;
    return ids.some((id) => menuItensIdsSet.has(id));
  };

  // Definir itens de menu por role
  const getMenuItems = () => {
    const commonItems = [{ label: 'Início', path: '/inicio', icon: '🏠' }];
    const baseItems = [
      { 
        label: 'Dashboards', 
        icon: '📊',
        submenu: [
          { label: 'Executivo', path: '/dashboard', icon: '💼' },
          { label: 'Financeiro', path: '/dashboard-financeiro', icon: '💰' },
          { label: 'Parcelas', path: '/dashboard-parcelas', icon: '🧾' },
          { label: 'Operacional', path: '/dashboard-operacional', icon: '📚' },
          { label: 'Comercial', path: '/dashboard-comercial', icon: '🎯' },
          { label: 'RH', path: '/dashboard-rh', icon: '👥' },
        ]
      },
    ];

    const itemsByRole = {
      ADMIN: [
        { 
          label: 'Dashboards', 
          icon: '📊',
          submenu: [
            { label: 'Executivo', path: '/dashboard', icon: '💼' },
            { label: 'Executivo V2', path: '/dashboard-executivo-v2', icon: '💼' },
            { label: 'Rentabilidade', path: '/dashboard-rentabilidade', icon: '📈' },
            { label: 'Financeiro', path: '/dashboard-financeiro', icon: '💰' },
            { label: 'Parcelas', path: '/dashboard-parcelas', icon: '🧾' },
            { label: 'Operacional', path: '/dashboard-operacional', icon: '📚' },
            { label: 'Comercial', path: '/dashboard-comercial', icon: '🎯' },
            { label: 'RH', path: '/dashboard-rh', icon: '👥' },
            { label: 'Unidades', path: '/dashboard-unidades', icon: '🏢' },
          ]
        },
        { 
          label: 'Sistema', 
          icon: '⚙️',
          submenu: [
            { label: 'Usuários', path: '/usuarios', icon: '👥' },
            { label: 'Perfis', path: '/perfis', icon: '🔐' },
            { label: 'Gestão de Dados', path: '/gestao-dados', icon: '🗄️' },
            { label: 'Bases', path: '/sistema/bases', icon: '🗃️' },
          ]
        },
        { 
          label: 'Unidades', 
          icon: '🏢',
          submenu: [
            { label: 'Unidades', path: '/unidades', icon: '🏢' },
            { label: 'Tipos de Unidades', path: '/tipo-unidades', icon: '📋' },
            { label: 'Tipos de Contrato', path: '/tipo-contratos', icon: '📑' },
            { label: 'Séries', path: '/series', icon: '🧩' },
            { label: 'Modalidades', path: '/modalidades', icon: '🎯' },
          ]
        },
        { 
          label: 'Equipe', 
          icon: '👨‍💼',
          submenu: [
            { label: 'Equipe', path: '/equipe', icon: '👨‍💼' },
            { label: 'Aulas Dadas', path: '/aulas-dadas', icon: '✅' },
            { label: 'Relatório Mensal', path: '/relatorio-mensal', icon: '💰' },
          ]
        },
        {
          label: 'Cadastros',
          icon: '🧾',
          submenu: [
            { label: 'Alunos', path: '/alunos', icon: '👨‍🎓' },
            { label: 'Responsáveis', path: '/responsaveis/pendentes', icon: '👤' },
          ]
        },
        {
          label: 'Acadêmico',
          icon: '🎓',
          submenu: [
            { label: 'Turmas', path: '/turmas', icon: '📚' },
            { label: 'Matrículas', path: '/matriculas', icon: '📝' },
            { label: 'Contratos', path: '/contratos', icon: '📄' },
            { label: 'Relatórios Operacionais', path: '/relatorios-operacionais', icon: '📑' },
          ]
        },
        {
          label: 'Financeiro',
          icon: '💵',
          submenu: [
            { label: 'Fluxo de Caixa', path: '/fluxo-caixa', icon: '📈' },
            { label: 'Relatórios Contábeis', path: '/relatorios-contabeis', icon: '📒' },
            { label: 'Receitas', path: '/receitas', icon: '💰' },
            { label: 'Parcelas', path: '/parcelas', icon: '🧾' },
            { label: 'Faturas - Operacional', path: '/faturas/operacional', icon: '⚙️' },
            { label: 'Faturas - Gestão', path: '/faturas/gestao', icon: '🗂️' },
            { label: 'Despesas', path: '/despesas', icon: '💸' },
            { label: 'Pagamentos', path: '/folha-pagamento', icon: '💵' },
            { label: 'Fornecedores', path: '/fornecedores', icon: '🏪' },
            { label: 'Categorias Despesa', path: '/categorias-despesa', icon: '🏷️' },
          ]
        },
        {
          label: 'Fiscal',
          icon: '🧾',
          submenu: [
            { label: 'Configuração Fiscal', path: '/fiscal/configuracao', icon: '⚙️' },
            { label: 'Emissão NFS-e', path: '/fiscal/emissao', icon: '📄' },
            { label: 'Notas Fiscais', path: '/fiscal/notas', icon: '📋' },
          ],
        },
      ],
      RH: [
        { label: 'Dashboard RH', path: '/dashboard-rh', icon: '📊' },
        { label: 'Dashboard Parcelas', path: '/dashboard-parcelas', icon: '🧾' },
        {
          label: 'Cadastros',
          icon: '🧾',
          submenu: [
            { label: 'Alunos', path: '/alunos', icon: '👨‍🎓' },
            { label: 'Responsáveis', path: '/responsaveis/pendentes', icon: '👤' },
          ]
        },
        {
          label: 'Acadêmico',
          icon: '🎓',
          submenu: [
            { label: 'Turmas', path: '/turmas', icon: '📚' },
            { label: 'Matrículas', path: '/matriculas', icon: '📝' },
            { label: 'Contratos', path: '/contratos', icon: '📄' },
            { label: 'Relatórios Operacionais', path: '/relatorios-operacionais', icon: '📑' },
          ]
        },
        { 
          label: 'Equipe', 
          icon: '👨‍💼',
          submenu: [
            { label: 'Equipe', path: '/equipe', icon: '👨‍💼' },
            { label: 'Aulas Dadas', path: '/aulas-dadas', icon: '✅' },
            { label: 'Relatório Mensal', path: '/relatorio-mensal', icon: '💰' },
          ]
        },
        { 
          label: 'Financeiro', 
          icon: '💵',
          submenu: [
            { label: 'Fluxo de Caixa', path: '/fluxo-caixa', icon: '📈' },
            { label: 'Relatórios Contábeis', path: '/relatorios-contabeis', icon: '📒' },
            { label: 'Receitas', path: '/receitas', icon: '💰' },
            { label: 'Parcelas', path: '/parcelas', icon: '🧾' },
            { label: 'Faturas - Operacional', path: '/faturas/operacional', icon: '⚙️' },
            { label: 'Faturas - Gestão', path: '/faturas/gestao', icon: '🗂️' },
            { label: 'Despesas', path: '/despesas', icon: '💸' },
            { label: 'Pagamentos', path: '/folha-pagamento', icon: '💵' },
            { label: 'Fornecedores', path: '/fornecedores', icon: '🏪' },
            { label: 'Categorias Despesa', path: '/categorias-despesa', icon: '🏷️' },
          ]
        },
      ],
      OFFICE: [
        { label: 'Dashboard Operacional', path: '/dashboard-operacional', icon: '📊' },
        { label: 'Dashboard Parcelas', path: '/dashboard-parcelas', icon: '🧾' },
        {
          label: 'Cadastros',
          icon: '🧾',
          submenu: [
            { label: 'Alunos', path: '/alunos', icon: '👨‍🎓' },
            { label: 'Responsáveis', path: '/responsaveis/pendentes', icon: '👤' },
          ]
        },
        {
          label: 'Acadêmico',
          icon: '🎓',
          submenu: [
            { label: 'Turmas', path: '/turmas', icon: '📚' },
            { label: 'Matrículas', path: '/matriculas', icon: '📝' },
            { label: 'Contratos', path: '/contratos', icon: '📄' },
            { label: 'Relatórios Operacionais', path: '/relatorios-operacionais', icon: '📑' },
          ]
        },
        { 
          label: 'Financeiro', 
          icon: '💵',
          submenu: [
            { label: 'Fluxo de Caixa', path: '/fluxo-caixa', icon: '📈' },
            { label: 'Relatórios Contábeis', path: '/relatorios-contabeis', icon: '📒' },
            { label: 'Receitas', path: '/receitas', icon: '💰' },
            { label: 'Parcelas', path: '/parcelas', icon: '🧾' },
            { label: 'Faturas - Operacional', path: '/faturas/operacional', icon: '⚙️' },
            { label: 'Faturas - Gestão', path: '/faturas/gestao', icon: '🗂️' },
            { label: 'Despesas', path: '/despesas', icon: '💸' },
            { label: 'Pagamentos', path: '/folha-pagamento', icon: '💵' },
            { label: 'Fornecedores', path: '/fornecedores', icon: '🏪' },
            { label: 'Categorias Despesa', path: '/categorias-despesa', icon: '🏷️' },
          ]
        },
      ],
      PROFESSOR: [
        { label: 'Minhas Aulas', path: '/aulas-dadas', icon: '✅' },
        { label: 'Turmas', path: '/turmas', icon: '📚' },
        { label: 'Pagamentos', path: '/folha-pagamento', icon: '💵' },
      ],
      ALUNO: [
        { label: 'Meus Dados', path: '/meus-dados', icon: '👤' },
        { label: 'Minhas Matrículas', path: '/minhas-matriculas', icon: '📝' },
        { label: 'Turmas Abertas', path: '/turmas-abertas', icon: '📚' },
      ],
      RESPONSAVEL: [
        { label: 'Portal do Responsável', path: '/responsavel/dashboard', icon: '🏠' },
        { label: 'Alunos', path: '/alunos', icon: '👨‍🎓' },
        { label: 'Matrículas', path: '/matriculas', icon: '📝' },
        { label: 'Turmas', path: '/turmas', icon: '📚' },
      ],
    };

    console.log('DEBUG_ROLE_KEY', {
      user,
      role: user?.role,
      perfil: user?.perfil,
    });
    const roleKey = (user?.role || user?.perfil || '').toString().trim().toUpperCase();
    console.log('DEBUG_ROLE_KEY', {
      user,
      role: user?.role,
      perfil: user?.perfil,
      roleKey,
    });
    console.log('[Sidebar] roleKey JSON:', JSON.stringify(roleKey));
    console.log('[Sidebar] roleKey length:', roleKey.length);
    const rawItems = itemsByRole[roleKey] || baseItems;

    console.log('[Sidebar] roleKey:', roleKey);
    console.log('[Sidebar] itemsByRole keys:', Object.keys(itemsByRole));
    console.log('[Sidebar] rawItems:', rawItems);
    console.log('[Sidebar] commonItems:', commonItems);

    const routeResourceMap = {
      '/dashboard': 'dashboards',
      '/dashboard-executivo-v2': 'dashboards',
      '/dashboard-rentabilidade': 'dashboards',
      '/dashboard-operacional': 'dashboards',
      '/dashboard-comercial': 'dashboards',
      '/dashboard-rh': 'dashboards',
      '/dashboard-financeiro': 'dashboards',
      '/dashboard-parcelas': 'dashboards',
      '/dashboard-unidades': 'dashboards',
      '/alunos': 'alunos',
      '/turmas': 'turmas',
      '/matriculas': 'matriculas',
      '/contratos': 'contratos',
      '/aulas-dadas': 'aulas_dadas',
      '/relatorio-mensal': 'relatorio_aulas',
      '/receitas': 'receitas',
      '/parcelas': 'parcelas',
      '/despesas': 'despesas',
      '/fluxo-caixa': 'fluxo_caixa',
      '/relatorios-contabeis': 'relatorios',
      '/relatorios-operacionais': 'relatorios_operacionais',
      '/fornecedores': 'fornecedores',
      '/categorias-despesa': 'categorias_despesa',
      '/folha-pagamento': 'folha_pagamento',
      '/equipe': 'equipe',
      '/usuarios': 'usuarios',
      '/perfis': 'perfis',
      '/responsaveis/pendentes': 'responsaveis',
      '/unidades': 'unidades',
      '/tipo-unidades': 'tipo_unidades',
      '/tipo-contratos': 'tipo_contratos',
      '/modalidades': 'modalidades',
      '/series': 'series',
      '/gestao-dados': 'export_import',
      '/fiscal/configuracao': 'config_fiscal',
      '/fiscal/emissao': 'nfse_emissao',
      '/fiscal/notas': 'nfse_rps',
      '/presencas': 'presencas',
      '/avaliacoes': 'avaliacoes_gestao',
      '/avaliacoes/validacao': 'avaliacoes_validacao',
      '/eventos': 'eventos',
      '/eventos/inscricoes': 'eventos',
      '/eventos/cobrancas': 'eventos',
    };

    const canAccess = (path) => {
      // ADMIN sempre vê tudo
      if (isAdmin) return true;

      // Enquanto permissões não carregaram ou falharam,
      // NÃO bloquear menu (fail-open controlado)
      if (permissaoLoading || !permissoes) {
        return true;
      }

      const recurso = routeResourceMap[path];

      // Rotas sem mapeamento explícito são públicas no menu
      if (!recurso) return true;

      return podeVisualizar(recurso);
    };

    const filterItems = (items) =>
      items
        .map((item) => {
          if (item.submenu) {
            const submenu = filterItems(item.submenu);
            if (!submenu.length) return null;
            console.log('[Sidebar] filterItems item:', item);
            console.log('[Sidebar] filterItems canAccess:', true);
            return { ...item, submenu };
          }
          if (item.path) {
            const allowed = canAccess(item.path) && perfilTemMenuItem(item.path);
            console.log('[Sidebar] filterItems item:', item);
            console.log('[Sidebar] filterItems canAccess:', allowed);
            if (!allowed) return null;
          }
          return item;
        })
        .filter(Boolean);

    // Gestão Administrativa de Presenças (Fase D — ajuste visual):
    // "Presenças" deve aparecer DENTRO do grupo "Acadêmico" existente da
    // role atual, não como item solto. Isto é PURAMENTE organizacional:
    // o item nunca é adicionado a nenhum array de itemsByRole (continua
    // fora do objeto `itemsByRole` inteiro, igual à Fase C) -- o que
    // muda é só ONDE, na árvore já montada em `rawItems`, ele é
    // injetado antes de `filterItems` rodar. A autorização continua
    // exclusivamente `canAccess('/presencas')` (que lê
    // podeVisualizar('presencas') via routeResourceMap acima, com
    // bypass de ADMIN já embutido) -- pertencer ao grupo Acadêmico não
    // concede acesso: um usuário com `turmas.visualizar` mas sem
    // `presencas.visualizar` continua sem ver o item, mesmo que o grupo
    // Acadêmico apareça para ele por causa de "Turmas".
    const itemPresencas = { label: 'Presenças', path: '/presencas', icon: '🗓️' };
    // Avaliações (Fase 7 do módulo): mesmo tratamento organizacional de
    // Presenças -- nunca entra em nenhum array de itemsByRole, só é
    // injetado no grupo Acadêmico já montado em `rawItems`. Autorização
    // continua exclusivamente `canAccess('/avaliacoes')` (lê
    // podeVisualizar('avaliacoes_gestao'), recurso ADMIN-only por
    // migration 079) -- pertencer ao grupo Acadêmico não concede acesso.
    const itemAvaliacoes = { label: 'Avaliações', path: '/avaliacoes', icon: '📝' };
    // Validações (Fase 12): recurso RBAC PRÓPRIO "avaliacoes_validacao",
    // DELIBERADAMENTE distinto de "avaliacoes_gestao" -- um perfil (ex.:
    // RH) pode ganhar `pode_visualizar` aqui pela tela Perfis sem ganhar
    // nenhum acesso a critérios/períodos/turmas. Mesmo tratamento
    // organizacional de Presenças/Avaliações acima.
    const itemValidacoes = { label: 'Validar Avaliações', path: '/avaliacoes/validacao', icon: '✅' };
    // Eventos (reorganizacao Sidebar -- grupo principal proprio): os 3
    // itens abaixo NUNCA entram em nenhum array de itemsByRole (mesmo
    // tratamento organizacional de Presencas/Avaliacoes/Validacoes
    // acima). Ate' esta mudanca, eram injetados dentro do submenu de
    // "Academico"; agora sao agrupados em um `grupoEventos` PROPRIO,
    // injetado como IRMAO de "Academico" (nao mais filho), logo apos
    // ele -- ver `grupoEventos`/`rawItemsComEventos` abaixo. Autorizacao
    // continua exclusivamente por `canAccess(path)` (le
    // podeVisualizar('eventos'), MESMO recurso RBAC unico para os 3,
    // routeResourceMap inalterado) -- mover o item de grupo visualmente
    // nao concede nem retira acesso algum.
    const itemEventos = { label: 'Eventos', path: '/eventos', icon: '📅' };
    // Inscrições (mesmo recurso RBAC "eventos" de itemEventos, nenhum
    // recurso novo). Label encurtado de "Inscrições de Eventos" para
    // "Inscrições" -- SOMENTE o label do Sidebar; path/recurso/titulo da
    // pagina (CobrancasEventosAdmin/InscricoesEventosAdmin) inalterados.
    const itemInscricoesEventos = { label: 'Inscrições', path: '/eventos/inscricoes', icon: '📋' };
    // Cobranças (mesmo recurso RBAC "eventos" de itemEventos/
    // itemInscricoesEventos, nenhum recurso novo). Label encurtado de
    // "Cobranças de Eventos" para "Cobranças" -- mesma ressalva acima.
    const itemCobrancasEventos = { label: 'Cobranças', path: '/eventos/cobrancas', icon: '💳' };
    // Grupo principal "Eventos" -- MESMA forma de objeto que qualquer
    // outro grupo em itemsByRole ({ label, icon, submenu }), para que
    // `filterItems` (abaixo) o trate de forma IDENTICA aos demais: filtra
    // os filhos por `canAccess`/`perfilTemMenuItem` e remove o grupo
    // inteiro se o submenu ficar vazio. Nenhuma checagem de permissao
    // paralela e' feita aqui.
    const grupoEventos = { label: 'Eventos', icon: '🎭', submenu: [itemEventos, itemInscricoesEventos, itemCobrancasEventos] };

    const grupoAcademico = rawItems.find((item) => item.label === 'Acadêmico' && item.submenu);
    const grupoAcademicoComExtras = grupoAcademico
      ? { ...grupoAcademico, submenu: [...grupoAcademico.submenu, itemPresencas, itemAvaliacoes, itemValidacoes] }
      : null;
    // Insere "Eventos" como IRMAO de "Academico", imediatamente depois
    // dele, preservando a ordem relativa de todos os outros grupos da
    // role (Secao 8 da instrucao) -- `flatMap` generaliza a insercao
    // ja usada para Presencas/Avaliacoes/Validacoes (que so' substituiam
    // o item no lugar) para permitir adicionar um elemento NOVO ao lado,
    // sem duplicar o literal completo de cada role.
    const rawItemsComEventos = grupoAcademico
      ? rawItems.flatMap((item) => (item === grupoAcademico ? [grupoAcademicoComExtras, grupoEventos] : [item]))
      : rawItems;

    const itensFiltrados = filterItems([...commonItems, ...rawItemsComEventos]);

    // Fallback: se a role atual não tiver grupo "Acadêmico" (ex.:
    // PROFESSOR/ALUNO/RESPONSAVEL), Presenças/Avaliações/Validações
    // continuam soltas, exatamente como antes desta mudança (Secao 14 --
    // logica desses 3 itens preservada). Os itens de Eventos NUNCA ficam
    // soltos (Secao 9 da instrucao): reaproveita o MESMO `filterItems`
    // sobre `[grupoEventos]` isolado -- se nenhum dos 3 filhos for
    // autorizado, `filterItems` remove o grupo inteiro (mesma regra de
    // "grupo vazio desaparece" usada no caminho principal, nenhuma
    // checagem paralela).
    if (!grupoAcademico) {
      if (canAccess('/presencas')) itensFiltrados.push(itemPresencas);
      if (canAccess('/avaliacoes')) itensFiltrados.push(itemAvaliacoes);
      if (canAccess('/avaliacoes/validacao')) itensFiltrados.push(itemValidacoes);
      const [grupoEventosFiltrado] = filterItems([grupoEventos]);
      if (grupoEventosFiltrado) itensFiltrados.push(grupoEventosFiltrado);
    }

    return itensFiltrados;
  };

  const menuItems = getMenuItems();

  const handleAlterarEmail = () => {
    setIsEmailModalVisible(true);
    emailForm.setFieldsValue({ novo_email: user.email });
  };

  const handleAlterarSenha = () => {
    setIsSenhaModalVisible(true);
  };

  const handleSubmitEmail = async (values) => {
    try {
      await usuarioService.alterarMeuEmail(values);
      message.success('Email alterado com sucesso! Por favor, faça login novamente.');
      emailForm.resetFields();
      setIsEmailModalVisible(false);
      setTimeout(() => logout(), 2000);
    } catch (error) {
      const errorMsg = error.response?.data?.detail 
        ? (typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : JSON.stringify(error.response.data.detail))
        : 'Erro ao alterar email';
      message.error(errorMsg);
    }
  };

  const handleSubmitSenha = async (values) => {
    try {
      await usuarioService.alterarMinhaSenha(values);
      message.success('Senha alterada com sucesso! Por favor, faça login novamente.');
      senhaForm.resetFields();
      setIsSenhaModalVisible(false);
      setTimeout(() => logout(), 2000);
    } catch (error) {
      const errorMsg = error.response?.data?.detail 
        ? (typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : JSON.stringify(error.response.data.detail))
        : 'Erro ao alterar senha';
      message.error(errorMsg);
    }
  };

  const profileMenu = (
    <Menu>
      <Menu.Item key="email" icon={<UserOutlined />} onClick={handleAlterarEmail}>
        Alterar Email
      </Menu.Item>
      <Menu.Item key="senha" icon={<KeyOutlined />} onClick={handleAlterarSenha}>
        Alterar Senha
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={logout} danger>
        Sair
      </Menu.Item>
    </Menu>
  );

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2 className="app-title">Fisicore</h2>
        <div className="user-badge">
          <span className={`role-badge role-${user.role.toLowerCase()}`}>{user.role}</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li key={item.path || item.label} className="nav-item">
              {item.submenu ? (
                <>
                  <div
                    className="nav-link nav-link-submenu"
                    onClick={() => toggleSubmenu(item.label)}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-label">{item.label}</span>
                    <span className="submenu-arrow">{openSubmenu === item.label ? '▼' : '▶'}</span>
                  </div>
                  {openSubmenu === item.label && (
                    <ul className="submenu">
                      {item.submenu.map((subitem) => (
                        <li key={subitem.path} className="submenu-item">
                          <Link to={subitem.path} className="submenu-link">
                            <span className="nav-icon">{subitem.icon}</span>
                            <span className="nav-label">{subitem.label}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <Link to={item.path} className="nav-link">
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        <Dropdown overlay={profileMenu} trigger={['click']} placement="topLeft">
          <div className="user-info" style={{ cursor: 'pointer' }}>
            <div className="user-avatar">
              {user.nome_completo.charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <p className="user-name">{user.nome_completo}</p>
              <p className="user-email">{user.email}</p>
            </div>
            <DownOutlined style={{ marginLeft: 'auto', fontSize: '12px' }} />
          </div>
        </Dropdown>
      </div>

      {/* Modal Alterar Email */}
      <Modal
        title="Alterar Email"
        open={isEmailModalVisible}
        onCancel={() => {
          setIsEmailModalVisible(false);
          emailForm.resetFields();
        }}
        footer={null}
      >
        <Form form={emailForm} onFinish={handleSubmitEmail} layout="vertical">
          <Form.Item
            label="Novo Email"
            name="novo_email"
            rules={[
              { required: true, message: 'Digite o novo email' },
              { type: 'email', message: 'Email inválido' }
            ]}
          >
            <Input placeholder="novo@email.com" />
          </Form.Item>
          <Form.Item
            label="Senha Atual"
            name="senha_atual"
            rules={[{ required: true, message: 'Digite sua senha atual para confirmar' }]}
          >
            <Input.Password placeholder="Digite sua senha atual" />
          </Form.Item>
          <Form.Item>
            <button type="submit" className="logout-btn" style={{ width: '100%' }}>
              Alterar Email
            </button>
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal Alterar Senha */}
      <Modal
        title="Alterar Senha"
        open={isSenhaModalVisible}
        onCancel={() => {
          setIsSenhaModalVisible(false);
          senhaForm.resetFields();
        }}
        footer={null}
      >
        <Form form={senhaForm} onFinish={handleSubmitSenha} layout="vertical">
          <Form.Item
            label="Senha Atual"
            name="senha_atual"
            rules={[{ required: true, message: 'Digite sua senha atual' }]}
          >
            <Input.Password placeholder="Senha atual" />
          </Form.Item>
          <Form.Item
            label="Nova Senha"
            name="nova_senha"
            rules={[
              { required: true, message: 'Digite a nova senha' },
              { min: 6, message: 'A senha deve ter pelo menos 6 caracteres' }
            ]}
          >
            <Input.Password placeholder="Nova senha (mínimo 6 caracteres)" />
          </Form.Item>
          <Form.Item
            label="Confirmar Nova Senha"
            name="confirmar_nova_senha"
            dependencies={['nova_senha']}
            rules={[
              { required: true, message: 'Confirme a nova senha' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('nova_senha') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('As senhas não coincidem'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirme a nova senha" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Alterar Senha
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </aside>
  );
};

export default Sidebar;
